var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdadReal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.8,
    height: 23.794,
    viewBox: "0 0 23.8 23.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12949",
    "data-name": "Group 12949",
    transform: "translate(-3750.523 -351.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7477",
    "data-name": "Path 7477",
    d: "M3993.891,375.3a.878.878,0,0,1-.543-.942c.018-1.177.008-2.355,0-3.532a.472.472,0,0,1,.158-.383,3.445,3.445,0,0,0,1.132-2.536c.012-1.084.03-2.17-.007-3.253a5.661,5.661,0,0,0-2.554-4.635.317.317,0,0,1-.163-.374,4.426,4.426,0,0,1,3.891-3.688c.027,0,.054-.015.153-.044a2.3,2.3,0,0,1-1.542-1.027,2.209,2.209,0,1,1,4.069-1.428,2.257,2.257,0,0,1-1.865,2.466c.189.032.321.053.452.077a4.422,4.422,0,0,1,3.6,3.76,1.257,1.257,0,0,0,.042.155v6c-.017.049-.038.1-.051.149a2.145,2.145,0,0,1-1.251,1.519.279.279,0,0,0-.191.311c0,2.16,0,4.321.009,6.481a.865.865,0,0,1-.56.93Z",
    transform: "translate(-226.399)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7478",
    "data-name": "Path 7478",
    d: "M3873.64,442.8a.8.8,0,0,1-.569-.9c.022-.471,0-.945.011-1.417a.43.43,0,0,1,.121-.274,3.561,3.561,0,0,0,1.159-2.48,6.658,6.658,0,0,0-.677-3.648,5.864,5.864,0,0,0-1.9-2.1.289.289,0,0,1-.159-.331,4.452,4.452,0,0,1,4-3.733l.13-.012c-1.471-.461-2.1-1.308-1.926-2.564a2.18,2.18,0,0,1,2.2-1.875,2.234,2.234,0,0,1,2.157,1.827c.2,1.236-.437,2.124-1.857,2.6a4.431,4.431,0,0,1,3.828,2.9,4.021,4.021,0,0,1,.275,1.521c0,.991.007,1.982,0,2.974a2.127,2.127,0,0,1-1.341,2.045.238.238,0,0,0-.151.267c0,1.432-.009,2.865.008,4.3a.819.819,0,0,1-.57.9Z",
    transform: "translate(-113.584 -67.497)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7479",
    "data-name": "Path 7479",
    d: "M3752.575,510.733a.851.851,0,0,1-.56-.93c.022-.673,0-1.348.01-2.021a.268.268,0,0,0-.191-.288,2.137,2.137,0,0,1-1.3-1.98,5.436,5.436,0,0,1,.328-2.441,4.369,4.369,0,0,1,3.53-2.711,1.032,1.032,0,0,0,.209-.053,2.305,2.305,0,0,1-1.476-.972,2.21,2.21,0,1,1,4.045-1.365,2.238,2.238,0,0,1-1.9,2.339c.264.048.483.078.7.129a4.414,4.414,0,0,1,3.417,4.222,6.337,6.337,0,0,1-.042,1.228,2.057,2.057,0,0,1-1.244,1.6.3.3,0,0,0-.208.329c.011.658-.012,1.317.01,1.975a.867.867,0,0,1-.543.943Z",
    transform: "translate(0 -135.434)",
    fill: "#394f65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdadReal);
export default __webpack_public_path__ + "static/media/edad_real.2a351399da9484dc7852ca56c813963d.svg";
export { ForwardRef as ReactComponent };